// TODO RND401K-7631: Remove feature flag logic after launch

export const OCTOBER_2023_PRICING = "oct-2023-pricing";
export const FEATURE_FLAG_KEYS = [OCTOBER_2023_PRICING] as const;

export type FeatureFlags = {
  [OCTOBER_2023_PRICING]?: boolean;
};
